import { render, staticRenderFns } from "./MsisdnListField.vue?vue&type=template&id=04d0431a&"
import script from "./MsisdnListField.vue?vue&type=script&lang=js&"
export * from "./MsisdnListField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports